export function safeParseJSON<T>(JSONString: string | null | undefined, defaultValue: T): T {
  try {
    return JSON.parse(JSONString ?? "");
  } catch {
    return defaultValue;
  }
}
